import PropTypes from 'prop-types';

/**
 * Date input component
 * 
 * @param {object} props
 * @param {string} props.id - component ID
 * @param {string} props.label - label text that appears above the input
 */
const DateInput = ({ id, label, value, setValue }) => {
    return (
        <>
            <label className='input-label' htmlFor={id}>{label}</label>
            <input
                type="datetime-local"
                id={id}
                value={value}
                onChange={setValue}
            />
        </>
    );
};

DateInput.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    setValue: PropTypes.func,
};

export default DateInput;